import { Component, OnInit, Inject, Input } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';

import { cellPhoneCommonValidators } from '@shared/core/validators/cell-phone.shared.validator';
import { cellPhoneTakenForSignInValidator } from '@shared/core/validators/cell-phone-taken.shared.validator';
import * as Services from '@shared/core/services';
import * as Tokens from '@shared/core/tokens';
import * as Utils from '@shared/core/utils';
import { Controllers } from '@shared/core/controllers';

import { FormTypesComponent } from '../form-types.shared.component';

import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { ILoyaltyAppCountryAssignmentModel } from '@shared/state';

@Component({
    selector: 'shared-form-for-sign-in-password',
    templateUrl: './form-for-sign-in-password.shared.component.html',
    styleUrls: ['./form-for-sign-in-password.shared.component.scss']
})
export class FormForSignInPasswordComponent extends FormTypesComponent implements OnInit {
    public currCountry: ICountries;
    public cellNo: string;
    public countryId: number;
    public countries: ILoyaltyAppCountryAssignmentModel[];
    @Input() public cellNumber: string; /* Is provided with format counryId:cellNumber */

    public signInError$: Observable<{ [key: string]: string; }>;

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        public formBuilder: FormBuilder,
        public controllers: Controllers,
        public membersService: Services.MembersService,
    ) {
        super(config, formBuilder);
        this.formName = 'sign-in-password';

        if (this.config.enableQuickSignInForReturningMembers) {
            this._setValuesIfReturningMember();
        }
    }

    ngOnInit(): void {
        this.currCountry = this.config.localization.country;
        this.loading$ = this.controllers.members.memberSignInStatus$();
        this.signInError$ = this.controllers.members.signInError$();
        this.controllers.appSettings.appGetCounrtries$().subscribe((countries) => {
            this.countries = countries;
            if (this.cellNumber) {
                if (this.cellNumber.charAt(0) !== '+' && this.cellNumber.includes(':')) {
                    this.cellNumber.split(':').forEach((str, index) => {
                        if (!index) {
                            this.countryId = +str;
                        } else {
                            this.cellNo = str;
                        }
                    });
                } else {
                    const mobileExtracted = Utils.MobilePhone.extractPhoneValues(this.currCountry, this.countries, this.cellNumber);

                    this.cellNo = mobileExtracted.raw;
                    if (!mobileExtracted.prefix) {
                        const country: ILoyaltyAppCountryAssignmentModel = this.countries.find(obj => obj.Code === this.currCountry);
                        if (country) {
                            this.countryId = country.Id;
                        }
                    } else {
                        this.countryId = mobileExtracted.countryPrefixId;
                    }
                }
            } else {
                console.warn('Cell number is not provided!', this.cellNumber);
            }

            this.formControl = this.formBuilder.group({
                countryPrefix: [
                    { value: this.countryId || '', disabled: true }
                ],
                cellNumber: [
                    { value: this.cellNo, disabled: true },
                ],
                password: [
                    { value: '', disabled: false },
                    [
                        Validators.required,
                    ]
                ],
            });
        });
    }

    public handleFormSubmit($event: Event): void {
        const formValues = this.getFormValues();

        this.controllers.members.getMemberDetails$()
            .pipe(
                take(1),
            )
            .subscribe(memberDetails => {
                if (memberDetails && memberDetails.MobilePhone) {
                    return this.controllers.members.signIn(memberDetails.MobilePhone, formValues.password);
                }

                const country: ILoyaltyAppCountryAssignmentModel = this.countries && this.countries.find(obj => obj.Id === formValues.countryPrefix);
                if (!country) {
                    return this.controllers.members.signIn(formValues.cellNumber, formValues.password); /* Original method */
                }

                return this.controllers.members.signIn(formValues.countryPrefix + formValues.cellNumber, formValues.password);

            });
    }

    public handleForgotPasswordClick($event: Event): void {
        this.controllers.members.setAuthStep(OLO.Enums.AUTH_STEP.FORGOT_PASSWORD);
    }

    public handleErrorButtonClick($event: Event): void {
        console.log('HANDLING BUTTON CLICK', $event, ($event.currentTarget as HTMLButtonElement).innerText);
    }

    private _setValuesIfReturningMember(): void {
        const countryId = +localStorage.getItem('user.countryId');
        const cellNumber = localStorage.getItem('user.cellNumber');

        if (isNaN(+countryId) || isNaN(+cellNumber)) return;

        this.countryId = countryId;
        this.cellNo = cellNumber;
        this.cellNumber = cellNumber;
    }
}
